import { getStore } from '../Store'
import { createAction } from '../ReduxUtils'

export enum GameServerAction {
    CONNECTING = 'GAME_SERVER_CONNECTING',
    CONNECTED = 'GAME_SERVER_CONNECTED',
    DISCONNECTED = 'GAME_SERVER_DISCONNECTED',
}

export function setConnectingState() {
    getStore().dispatch(
        createAction(GameServerAction.CONNECTING)
    )
}

export function setConnectedState() {
	getStore().dispatch(
        createAction(GameServerAction.CONNECTED)
    )
}

export function setDisconnectedState() {
	getStore().dispatch(
        createAction(GameServerAction.DISCONNECTED)
    )
}
